import * as v from 'valibot';
import {
  CONTACT_INTEREST_OPTIONS,
  CONTACT_ROLE_OPTIONS,
} from '#marketing/lib/marketing-contact-constants.js';
import {
  optionalOrgDisplayNameField,
  optionalSingleLineBasicField,
  personDisplayNameField,
  plainMultilineField,
} from '#lib/plain-text-validation.js';

/**
 * Build the contact form schema with localized validation messages.
 *
 * @param {(key: string) => string} t
 */
export function getContactSchema(t) {
  const roleSchema = v.picklist(CONTACT_ROLE_OPTIONS, t('marketing.contactValidation.roleRequired'));
  const interestSchema = v.picklist(
    CONTACT_INTEREST_OPTIONS,
    t('marketing.contactValidation.interestRequired'),
  );

  return v.object({
    name: personDisplayNameField({
      minLengthMessage: t('marketing.contactValidation.nameRequired'),
    }),
    email: v.pipe(v.string(), v.email(t('marketing.contactValidation.emailInvalid'))),
    role: roleSchema,
    schoolName: v.optional(optionalOrgDisplayNameField()),
    cityOrDistrict: v.optional(optionalSingleLineBasicField()),
    interest: interestSchema,
    message: plainMultilineField({
      minLength: 10,
      minLengthMessage: t('marketing.contactValidation.messageTooShort'),
    }),
    marketingConsent: v.optional(v.boolean()),
    company: v.optional(optionalSingleLineBasicField()),
    turnstileToken: v.pipe(
      v.string(),
      v.minLength(1, t('marketing.contactValidation.turnstileRequired')),
    ),
  });
}
